import MaterialIconButton from '@material-ui/core/IconButton';
import { disabling } from '@/components/disabling';
const IconButton = disabling(MaterialIconButton);
export default IconButton;
